import { render, staticRenderFns } from "./select-from-list.vue?vue&type=template&id=2f8c0086&scoped=true&"
import script from "./select-from-list.vue?vue&type=script&lang=js&"
export * from "./select-from-list.vue?vue&type=script&lang=js&"
import style0 from "./select-from-list.vue?vue&type=style&index=0&id=2f8c0086&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8c0086",
  null
  
)

export default component.exports